<template>
  <div class="dark-swtich-btn">
    <button
      style="height: 35px; width: 35px;"
      class="switch-toggle transition d-inline-block position-relative border-0 rounded-circle"
      id="switch-toggle"
      @click="theme.toggle()"
    >
      <i :class="theme.isDark ? 'flaticon-moon' : 'flaticon-sun'"></i>
    </button>
  </div>
</template>

<script setup>
import { useThemeStore } from "@/stores/theme";
const theme = useThemeStore();
</script>